import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function AwaitingPaymentIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 105 90"
      height={height}
      width={width}
    >
      <path
        className="st0"
        d="M24.5169182,34.894619c-0.6366444,0-1.1553631-0.516983-1.1553631-1.155365v-9.9030533  c0-0.6375027,0.5187187-1.1544876,1.1553631-1.1544876c0.6375027,0,1.1545048,0.5169849,1.1545048,1.1544876v8.7485695h5.2877235
         c0.6366444,0,1.1536274,0.516983,1.1536274,1.1544838c0,0.638382-0.516983,1.155365-1.1536274,1.155365H24.5169182  L24.5169182,34.894619z M73.2759094,53.3017349c1.6959229,0,3.0765915,1.3806267,3.0765915,3.0774651
         c0,1.6959267-1.3806686,3.0765533-3.0765915,3.0765533c-1.6976624,0-3.0765533-1.3806267-3.0765533-3.0765533  C70.1993561,54.6823616,71.5782471,53.3017349,73.2759094,53.3017349L73.2759094,53.3017349z M67.8895111,56.3792
         c0,2.9700165,2.4163666,5.3864021,5.3863983,5.3864021c2.9700699,0,5.3846664-2.4163857,5.3846664-5.3864021  c0-2.970089-2.4145966-5.3864555-5.3846664-5.3864555C70.3058777,50.9927444,67.8895111,53.409111,67.8895111,56.3792
         L67.8895111,56.3792z M85.3333664,65.1425705V47.6148949H70.8682785c-3.1106567,0-5.6440506,2.4486618-5.6440506,5.4580116  v6.6125336c0,3.0093498,2.5333939,5.4571304,5.6440506,5.4571304H85.3333664L85.3333664,65.1425705z M81.5476532,76.1128082
         c2.0880585,0,3.7857132-1.69944,3.7857132-3.7865829V67.452446H70.8682785c-4.3847656,0-7.9521294-3.4844284-7.9521294-7.7670059  v-6.6125336c0-4.2825813,3.5673637-7.7670021,7.9521294-7.7670021h14.4650879v-4.8729286
          c0-2.0880013-1.6976547-3.7874374-3.7857132-3.7874374H40.4150734c-1.3972778,7.6580238-8.1270523,13.375042-16.2448711,13.2503433  v22.4303436c0,2.0871429,1.6994343,3.7865829,3.7865791,3.7865829H81.5476532L81.5476532,76.1128082z M10.6666489,33.739254
          c0,7.6377678,6.2125034,13.8512039,13.8502693,13.8512039c7.6386223,0,13.8512039-6.2134361,13.8512039-13.8512039  c0-7.6368866-6.2125816-13.8503246-13.8512039-13.8503246C16.8791523,19.8889294,10.6666489,26.1023674,10.6666489,33.739254
           L10.6666489,33.739254z M73.3850784,22.9078922c1.0217438-0.1187458,1.8199158,0.3746605,2.3098526,0.8095627  c1.0418091,0.9265347,1.6880264,2.4530506,1.6880264,3.9865284v6.6326218H40.6648293
           c0.0931244-2.6464577-0.4336052-5.1380577-1.4994087-7.4185505L73.3850784,22.9078922L73.3850784,22.9078922z   M81.5476532,34.3366051h-1.8565598v-6.6326218c0-3.803709-2.8500519-7.525774-6.5749817-7.0893459L37.931427,24.737421
            c-2.905407-4.3149128-7.8342056-7.1583042-13.4145088-7.1583042c-8.9118557,0-16.1601372,7.2500191-16.1601372,16.1601372  c0,8.0071259,5.851862,14.6712036,13.5053453,15.941803v22.6451683c0,3.36129,2.7334213,6.0946579,6.094656,6.0946579h53.5908737
             c3.3604279,0,6.0955658-2.7333679,6.0955658-6.0946579V40.4329758C87.643219,37.071743,84.9080811,34.3366051,81.5476532,34.3366051  z"
        style={{
          fill: color,
          fillRule: 'evenodd',
          clipRule: 'evenodd'
        }}
      />
    </svg>
  )
}